import gql from 'graphql-tag';
const FANCY_FORMATTING_ACTIVITY_FRAGMENT = gql `
  fragment FancyFormattingActivityFragment on FancyFormattingActivity {
    rounds {
      id
      instructions
      contentImage {
        id
        image {
          description
          id
          src
        }
      }
      steps {
        id
        answer
        bold
        italic
        underline
      }
    }
  }
`;
export default FANCY_FORMATTING_ACTIVITY_FRAGMENT;
